import React from "react";

import styles from "./ContactUs.module.css";
import { pattern } from "../../images/images";

const ContactUs = () => {
  return (
    <section className={styles.wrapper} id="contactus">
      <img src={pattern} alt="#" className={styles.pattern} />
      <h2 className={styles.title}>Contact us</h2>
      <p className={styles.text}>
        We're here to help. Reach out anytime.
      </p>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.iconCircle}>
            <svg
              className={styles.icon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
              />
            </svg>
          </div>
          <h3 className={styles.cardTitle}>Email Support</h3>
          <p className={styles.cardText}>
            Have a question, feedback, or need help? Send us an email and
            we'll get back to you as soon as possible.
          </p>
          <a
            href="mailto:support@chitchatgame.com"
            className={styles.button}
          >
            <svg
              className={styles.buttonIcon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            support@chitchatgame.com
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
